import React, { useRef, useState } from "react";
import CardFlip from "react-card-flip";

import IconPlus from "../icons/plus-dark.svg";
import S from "./styles";
import PropTypes from "prop-types";

import useOutsideClick from "../../../hooks/useOutsideClick";

import IconBeta from "../icons/beta.png";
import { Tooltip } from "antd";

const urlImage = "https://images.e-auditoria.com.br";

function Flipper({ back, beta, internal, icon, title, description, onClick, tooltipTitle = '', planilha = false, desabilitado = false }) {
  const flipRef = useRef();
  const [isFlipped, setFlipped] = useState(false);

  useOutsideClick(flipRef, () => {
    if (isFlipped) setFlipped(false);
  });

  return (
    <CardFlip isFlipped={isFlipped}>
      <S.Flipper>
        {back && (
          <S.FlipButton
            src={IconPlus}
            alt="Virar"
            onClick={() => setFlipped(true)}
          />
        )}

        {beta && <S.Beta src={IconBeta} />}

        <S.Container>
          <S.Icon src={icon} alt={title} />
          <S.Title>{title}</S.Title>
        </S.Container>

        <div className="text-center">
          {planilha ? <S.ButtonArrow
            type="link"
            size="large"
            icon="download"
            onClick={onClick}
          /> : (internal ? (
            <S.ButtonArrow
              type="link"
              size="large"
              icon="arrow-right"
              onClick={onClick}
            />
          ) : (
            tooltipTitle ?
              <Tooltip title={tooltipTitle} overlayStyle={{minWidth: '50vh'}}>
                <S.Button type="primary" size="large" onClick={onClick} disabled={desabilitado}>
                  acesse aqui
                </S.Button>
              </Tooltip> :
              <S.Button type="primary" size="large" onClick={onClick} disabled={desabilitado}>
                acesse aqui
              </S.Button>
          ))}
        </div>
      </S.Flipper>

      <S.Flipper>
        <div ref={flipRef} className="flipper__back">
          <S.FlipButton
            src={IconPlus}
            alt="Virar"
            onClick={() => setFlipped(false)}
          />

          {beta && <S.Beta src={IconBeta} />}

          <S.Container>
            <S.Icon
              src={`${urlImage}/global/logos/svg/eauditoria-mini-dark.svg`}
              alt={title}
              height={32}
            />
            <S.Description>{description}</S.Description>
          </S.Container>
        </div>
      </S.Flipper>
    </CardFlip>
  );
}

Flipper.defaultProps = {
  back: true,
  beta: false,
  internal: false,
};

Flipper.propTypes = {
  back: PropTypes.bool,
  beta: PropTypes.bool,
  internal: PropTypes.bool,
};

export default Flipper;
